import { createStore } from 'vuex';
import authModule from './modules/auth/index.js';
import clientModule from './modules/client/index.js';
import reservingFiltersModule from './modules/reservingFilters/index.js';
import configurationModule from './modules/configs/index.js';

export default createStore({
  state() {
    return {
      apiBaseURL: 'https://api.organic-minded.com', // When You set to this position,
      // apiBaseURL: 'https://localhost:44395', //My Local Host
      // apiBaseURL: 'http://31.214.169.122:8060', //Test Server Local IP
      version: 'v 1.1',
      requetCount: 0,
      currentDateTime: '',
      inMaintenance: 'false',
      currentGregorianDateTime: '',
      fileUploadLimitation: {
        userPic: {
          size: 500, //in kb
          type: 'KB',
        },
        receiptFile: {
          size: 2, //in mb
          type: 'MB',
        },
      },
      // recaptchaSecretKey: '6LfbcQYqAAAAAIJSgK6wDtD8wvN7AQLh8Ihc5bwc',
    };
  },
  modules: {
    auth: authModule,
    client: clientModule,
    reservingFilters: reservingFiltersModule,
    configuration: configurationModule,
  },
});
